import { clone } from '@jack-henry/frontend-utils/functions';
import { FileFormatModelDto } from '@treasury/api/channel';
import { format } from 'date-fns';
import { DomainEntity } from '../shared';

export const nullWireUploadFormat: FileFormatModelDto = {
    templateName: '',
    fileFormatType: '',
    fieldDelimiter: '',
    headerRows: 0,
    footerRows: 0,
    fileFormatDetails: [
        {
            fileFormatField: '',
            order: 0,
            beginPosition: 0,
            endPosition: 0,
            additionalInformationOne: '',
            additionalInformationTwo: '',
            additionalInformationThree: '',
            additionalInformationFour: '',
            id: 0,
            updatedBy: '',
            updatedDate: '',
        },
    ],
    id: 0,
    updatedBy: '',
    updatedDate: '',
};

export class WireUploadFormat extends DomainEntity<FileFormatModelDto> {
    constructor(dto = clone(nullWireUploadFormat)) {
        super(clone(dto));
    }

    public createDefault(): this {
        return new WireUploadFormat(clone(nullWireUploadFormat)) as this;
    }

    public get id() {
        return this.dto.id;
    }

    public get formatName() {
        return this.dto.templateName;
    }

    public get formatType() {
        return this.dto.fileFormatType;
    }

    public get updatedBy() {
        return this.dto.updatedBy;
    }

    public get updatedDate() {
        return this.dto.updatedDate;
    }

    public get updatedDateFormatted() {
        return format(new Date(this.dto.updatedDate), 'MM/dd/yyyy');
    }
}
